import { type UseQueryOptions, type UseQueryResult, useQuery } from "@tanstack/react-query"
import type { TDBItem } from "@/types"
import type { IAPIParams } from "@/utils"

import type { TAPIResource } from "./utils"

export function useAPIResources<F extends string, S extends string, T extends TDBItem>(
  { fetchMany, url }: TAPIResource<T>,
  params: IAPIParams<F, S> & Omit<UseQueryOptions, "queryKey" | "queryFn"> = {},
  opts?,
) {
  const { where, sort, limit, offset, ...props } = params
  return useQuery({
    ...props,
    meta: { list: true },
    queryKey: [url(opts), "list", { where, sort, limit, offset }],
    queryFn: () => fetchMany({ where, sort, limit, offset }, opts),
  }) as UseQueryResult<Awaited<ReturnType<typeof fetchMany>>>
}
